import { PageRef } from 'providers/page-ref';

export type UserProfilePageParams = {};

export const IUserProfilePage: PageRef<UserProfilePageParams, void> = {
  pageName: 'UserProfilePage',
} as PageRef<UserProfilePageParams, void>;
